// extracted by mini-css-extract-plugin
export default {"BlinkingBackground":"Boards_BlinkingBackground__s4jI6","blink":"Boards_blink__61P2D","Boards":"Boards_Boards__Tp2NX"};